// extracted by mini-css-extract-plugin
module.exports = {"clock":"clock_clock__iIOv8","clock__time":"clock_clock__time__3uh_z","clock__paragraph":"clock_clock__paragraph__3Kz_N"};